import * as getters from './getters'
import * as actions from './actions'
import mutations from './mutations'

const state = {
  status: [
    {
      value: 1,
      label: '公開'
    },
    {
      value: 0,
      label: '非公開'
    }
  ],
  project: [
    {
      value: 1,
      label: 'Commission'
    },
    {
      value: 2,
      label: 'Original'
    }
  ],
  enabled: [
    {
      value: 1,
      label: '有効'
    },
    {
      value: 0,
      label: '無効'
    }
  ],
  type: [
    {
      value: 1,
      label: 'Art'
    },
    {
      value: 2,
      label: 'Works'
    }
  ],
  art_status: [
    {
      value: null,
      label: '未設定'
    },
    {
      value: 1,
      label: 'UPCOMING / 開催間近'
    },
    {
      value: 2,
      label: 'CURRENT / 開催中'
    }
  ],
  target: [
    {
      value: 'self',
      label: 'リンクを別タブで表示しない'
    },
    {
      value: 'blank',
      label: 'リンクを別タブで表示する'
    }
  ],
  tags: [],
  tags_art: [],
  work_media_type: [],
  work_project_type: [],
  stories_tag: [],
  stories_project_type: []
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/options/index.js